import { defineComponent as _defineComponent } from 'vue'
import { BaseText, Link } from '@warrenbrasil/nebraska-web';

import { regulationTexts } from './texts';

export default /*#__PURE__*/_defineComponent({
  __name: 'Regulation',
  setup(__props) {


return { __sfc: true,BaseText, Link, regulationTexts }
}

})